import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";

const RiskReviewPanel = ({ children, p = 4, variant = "primary", ...props }) => {
  const bg = useColorModeValue(
    variant === "subtle" ? "gray.50" : "white",
    variant === "subtle" ? "whiteAlpha.50" : "gray.800",
  );
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="md"
      boxShadow={variant === "elevated" ? "md" : "none"}
      p={p}
      {...props}
    >
      {children}
    </Box>
  );
};

export default RiskReviewPanel;
